import { mapState } from 'vuex';

export default {
    name: 'articlestatic',
    props: {
        module : String,
        wnd : Boolean
    },

    data : function(){

        return {
            loading : false
        }

    },

    components : {
        strategy : () => import("./strategy/index.vue"),
    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        
    }),

    methods : {
        close : function(){
            this.$emit('close')
        }
    },
}